import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/password/reset-request", { email });
      setSent(true);
      if (r.data.reset_token_dev) setDevToken(r.data.reset_token_dev);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background" data-testid="forgot-page">
      <Card className="p-8 lg:p-10 w-full max-w-md">
        <h1 className="font-serif text-3xl font-black tracking-tight">Forgot password</h1>
        <p className="text-sm text-muted-foreground mt-2">Enter your email and we'll send you instructions to reset it.</p>
        {sent ? (
          <div className="mt-6 space-y-4">
            <p className="text-sm">If an account exists for that email, a password reset link has been sent.</p>
            {devToken && (
              <div className="text-xs border border-border rounded p-3">
                <p className="uppercase tracking-widest text-primary mb-1">Dev-only reset link</p>
                <Link to={`/reset-password?token=${devToken}`} className="text-primary underline break-all" data-testid="dev-reset-link">
                  /reset-password?token={devToken}
                </Link>
              </div>
            )}
            <Link to="/login" className="text-sm text-primary underline underline-offset-4">Return to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" /></div>
            <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="forgot-submit">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
            <p className="text-xs text-center"><Link to="/login" className="text-muted-foreground hover:text-foreground">Back to sign in</Link></p>
          </form>
        )}
      </Card>
    </div>
  );
}
